import useBeautyFilterMenu from 'hooks/beautyFilter/useBeautyFilterMenu';
import useBeautyFilterImage from 'hooks/beautyFilter/useBeautyFilterImage';

const BeautyFilterMenu: React.FC = () => {
  const { items, handleButtonClick, isItemSelected, isItemDisabled } = useBeautyFilterMenu();

  return (
    <>
      <div className="flex h-14 w-full items-center gap-3 bg-[var(--bk-200)] px-4">
        {items.map((item) => (
          <div
            key={item.id}
            onClick={() => handleButtonClick(item)}
            className={`${isItemDisabled(item) ? 'opacity-40' : ''} flex h-full items-center justify-center`}
          >
            <BeautyFilterMenuImage id={item.id} src={item.thumbnail} isItemSelected={isItemSelected(item.id)} />
          </div>
        ))}
      </div>
      {Device.name === 'iOS' && <div className="h-[var(--sab)] w-full bg-[var(--bk-200)]" />}
    </>
  );
};

const BeautyFilterMenuImage: React.FC<{ id: string; src: string; isItemSelected: boolean }> = ({ id, src, isItemSelected }) => {
  const { endLoadingImage } = useBeautyFilterImage(src);
  return (
    <div className={`${isItemSelected ? 'bg-white/10' : ''} flex h-8 w-8 items-center justify-center rounded-full`}>
      <img
        src={src}
        alt={id}
        className={`${isItemSelected ? 'filter-base-ic-green' : ''} h-4 w-4 rounded-full`}
        onLoad={() => endLoadingImage(src)}
        onError={() => endLoadingImage(src)}
      />
    </div>
  );
};

export default BeautyFilterMenu;
